/**
 * SitemapHero — Weidner Via6 page hero for /sitemap.
 * See `FloorPlansHero.tsx` and `_PageImageHeroBody.tsx` for the shared
 * pattern. Owns its slot registration, contentSchema, and hidden
 * literal-path anchors; visual rendering is delegated to the body.
 */

import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { RichTextContent, EditableSlotGroup } from '@vibesites/runtime/react';
import { PageImageHeroBody } from './_PageImageHeroBody';

const bgDef = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Sitemap hero image',
    },
  },
  sourceBinding: {
    collection: 'photo_gallery',
    defaultIndex: 0,
    fieldMappings: { image: 'image', alt: 'alt_text' },
  },
};

export function SitemapHero() {
  return (
    <>
      <PageImageHeroBody
        titlePath="sitemaphero.title"
        bgPath="sitemaphero.bg_image"
        bgDef={bgDef}
        defaultTitle="Sitemap"
        keywords={[]}
        pageHint="sitemaphero"
        altText="Sitemap hero image"
      />

      <RichTextContent
        path="sitemaphero.title"
        as="span"
        className="hidden"
        style={{ display: 'none' }}
      />
      <EditableSlotGroup
        groupPath="sitemaphero.bg_image"
        definition={bgDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'SitemapHero',
  displayName: 'Sitemap Hero',
  tokens: {
    'sitemaphero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: 'Sitemap',
    },
  },
  slotGroups: {
    'sitemaphero.bg_image': {
      label: 'Background Image',
      fields: {
        image: {
          label: 'Image',
          type: 'image',
          defaultField: 'property_featured_image',
        },
        alt: {
          label: 'Alt Text',
          type: 'text',
          defaultValue: 'Sitemap hero image',
        },
      },
      sourceBinding: {
        collection: 'photo_gallery',
        defaultIndex: 0,
        fieldMappings: { image: 'image', alt: 'alt_text' },
      },
    },
  },
};

(SitemapHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default SitemapHero;
